import { createSelector } from 'reselect';
import { CARE_ORDER_PLAN_KEY } from '../../../config/careOrderPlan';
const initialState = {
    isCareClientVisitorProfileInitialized: false,
    isRemoteConfigInitialized: false,
    doAgreePlatformPolicy: null,
    carouselCurrentActiveItemKey: CARE_ORDER_PLAN_KEY.ALL_DAY,
    carouselPrevActiveItemKey: CARE_ORDER_PLAN_KEY.ALL_DAY,
};
var ACTION_TYPES;
(function (ACTION_TYPES) {
    ACTION_TYPES["TRACKER_IS_CARE_CLIENT_VISITOR_PROFILE_INITIALIZED_SET_TRUE"] = "tracker/isCareClientVisitorProfileInitialized/setTrue";
    ACTION_TYPES["TRACKER_IS_CARE_CLIENT_VISITOR_PROFILE_INITIALIZED_RESET"] = "tracker/isCareClientVisitorProfileInitialized/reset";
    ACTION_TYPES["TRACKER_IS_REMOTE_CONFIG_INITIALIZED_SET_TRUE"] = "tracker/isRemoteConfigInitialized/setTrue";
    ACTION_TYPES["TRACKER_IS_REMOTE_CONFIG_INITIALIZED_RESET"] = "tracker/isRemoteConfigInitialized/reset";
    ACTION_TYPES["TRACKER_DO_AGREE_PLATFORM_POLICY_SET_TRUE"] = "tracker/doAgreePlatformPolicy/setTrue";
    ACTION_TYPES["TRACKER_DO_AGREE_PLATFORM_POLICY_SET_FALSE"] = "tracker/doAgreePlatformPolicy/setFalse";
    ACTION_TYPES["TRACKER_CAROUSEL_CURRENT_ACTIVE_ITEM_KEY_UPDATE"] = "tracker/carouselCurrentActiveItemKey/update";
    ACTION_TYPES["TRACKER_CAROUSEL_PREV_ACTIVE_ITEM_KEY_UPDATE"] = "tracker/carouselPrevActiveItemKey/update";
})(ACTION_TYPES || (ACTION_TYPES = {}));
export default function trackerReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.TRACKER_IS_CARE_CLIENT_VISITOR_PROFILE_INITIALIZED_SET_TRUE:
            return { ...state, isCareClientVisitorProfileInitialized: true };
        case ACTION_TYPES.TRACKER_IS_CARE_CLIENT_VISITOR_PROFILE_INITIALIZED_RESET:
            return { ...state, isCareClientVisitorProfileInitialized: false };
        case ACTION_TYPES.TRACKER_IS_REMOTE_CONFIG_INITIALIZED_SET_TRUE:
            return { ...state, isRemoteConfigInitialized: true };
        case ACTION_TYPES.TRACKER_IS_REMOTE_CONFIG_INITIALIZED_RESET:
            return { ...state, isRemoteConfigInitialized: false };
        case ACTION_TYPES.TRACKER_DO_AGREE_PLATFORM_POLICY_SET_TRUE:
            return { ...state, doAgreePlatformPolicy: true };
        case ACTION_TYPES.TRACKER_DO_AGREE_PLATFORM_POLICY_SET_FALSE:
            return { ...state, doAgreePlatformPolicy: false };
        case ACTION_TYPES.TRACKER_CAROUSEL_CURRENT_ACTIVE_ITEM_KEY_UPDATE:
            return { ...state, carouselCurrentActiveItemKey: action.payload };
        case ACTION_TYPES.TRACKER_CAROUSEL_PREV_ACTIVE_ITEM_KEY_UPDATE:
            return { ...state, carouselPrevActiveItemKey: action.payload };
        default:
            return state;
    }
}
// actions
export const trackerIsCareClientVisitorProfileInitializedSetTrue = () => ({
    type: ACTION_TYPES.TRACKER_IS_CARE_CLIENT_VISITOR_PROFILE_INITIALIZED_SET_TRUE,
});
export const trackerIsCareClientVisitorProfileInitializedReset = () => ({
    type: ACTION_TYPES.TRACKER_IS_CARE_CLIENT_VISITOR_PROFILE_INITIALIZED_RESET,
});
export const trackerIsRemoteConfigInitializedSetTrue = () => ({
    type: ACTION_TYPES.TRACKER_IS_REMOTE_CONFIG_INITIALIZED_SET_TRUE,
});
export const trackerIsRemoteConfigInitializedReset = () => ({
    type: ACTION_TYPES.TRACKER_IS_REMOTE_CONFIG_INITIALIZED_RESET,
});
export const trackerDoAgreePlatformPolicySetTrue = () => ({
    type: ACTION_TYPES.TRACKER_DO_AGREE_PLATFORM_POLICY_SET_TRUE,
});
export const trackerDoAgreePlatformPolicySetFalse = () => ({
    type: ACTION_TYPES.TRACKER_DO_AGREE_PLATFORM_POLICY_SET_FALSE,
});
export const trackerCarouselCurrActiveItemKeyUpdate = (payload) => ({
    type: ACTION_TYPES.TRACKER_CAROUSEL_CURRENT_ACTIVE_ITEM_KEY_UPDATE,
    payload,
});
export const trackerCarouselPrevActiveItemKeyUpdate = (payload) => ({
    type: ACTION_TYPES.TRACKER_CAROUSEL_PREV_ACTIVE_ITEM_KEY_UPDATE,
    payload,
});
// selectors
export const selectIsCareClientVisitorProfileInitialized = createSelector((state) => state.tracker.isCareClientVisitorProfileInitialized, (isCareClientVisitorProfileInitialized) => isCareClientVisitorProfileInitialized);
export const selectIsRemoteConfigInitialized = createSelector((state) => state.tracker.isRemoteConfigInitialized, (isRemoteConfigInitialized) => isRemoteConfigInitialized);
export const selectDoAgreePlatformPolicy = createSelector((state) => state.tracker.doAgreePlatformPolicy, (doAgreePlatformPolicy) => doAgreePlatformPolicy);
export const selectCarouselCurrentActiveItemKey = createSelector((state) => state.tracker.carouselCurrentActiveItemKey, (carouselCurrentActiveItemKey) => carouselCurrentActiveItemKey);
export const selectCarouselPrevActiveItemKey = createSelector((state) => state.tracker.carouselPrevActiveItemKey, (carouselPrevActiveItemKey) => carouselPrevActiveItemKey);
